import { Component, computed, inject, input } from '@angular/core';

import { ProgressBarComponent, ProgressSegment } from '@eiq/ui';
import { Translation } from '@empathy/survey-core';

import { EditorTranslationsService } from '../../../services/editor-translations.service';

@Component({
  standalone: true,
  selector: 'empathy-translations-status',
  templateUrl: './translations-status.component.html',
  styleUrls: ['./translations-status.component.scss'],
  imports: [ProgressBarComponent]
})
export class TranslationsStatusComponent {
  translation = input.required<Translation>();

  translationsService = inject(EditorTranslationsService);

  translatedCount$ = computed(() => this.translationsService.translatedCount(this.translation()));
  missingCount$ = computed(() => this.translationsService.missingCount(this.translation()));
  outdatedCount$ = computed(() => this.translation().entries.filter((e) => e.outdatedInd).length);
  ignoredCount$ = computed(() => this.translation().entries.filter((e) => e.ignoredInd).length);

  segments$ = computed<ProgressSegment[]>(() => [
    { value: this.translatedCount$(), label: 'Translated', color: 'success' },
    { value: this.ignoredCount$(), label: 'Ignored', color: 'warn' },
    { value: this.outdatedCount$(), label: 'Outdated', color: 'alert', excludeFromTotal: true }
  ]);

  total$ = computed(() => this.translatedCount$() + this.missingCount$() + this.outdatedCount$() + this.ignoredCount$());
}
